import { Modal as ModalANTD, ModalProps } from 'antd';
import { useRef } from 'react';

interface AccessibleModalProps extends ModalProps {
  'aria-label'?: string;
  'aria-describedby'?: string;
  'aria-labelledby'?: string;
}

export const Modal = ({ 'aria-label': ariaLabel, 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledby, children, ...props }: AccessibleModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null);

  return (
    <ModalANTD
      modalRender={(modal) => (
        <div
          ref={modalRef}
          role="dialog"
          aria-modal="true"
          aria-label={ariaLabel}
          aria-describedby={ariaDescribedby}
          aria-labelledby={ariaLabelledby}
          className="focus-trap"
        >
          {modal}
        </div>
      )}
      {...props}
    >
      {children}
    </ModalANTD>
  );
};
